import 'ui-theme/js/components/_tabs';

const tabs = UX.tab;
const $body = $('body');

tabs.additionalControl = function () {
    $body.on('click', '.tab__nav a', function () {
        const _this = $(this);
        const tabId = tabs.getPaneTarget(_this);

        $(this).closest('.tab').find('.tab__pane').removeClass('active');
        $(this)
            .closest('.tab')
            .find('#' + tabId.split('#')[1])
            .addClass('active');
    });
};
